import { useState, useEffect } from 'react';
import './candidateEducation.css';
import { faChevronDown, faChevronUp, faPen, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row, Modal, Form, Button } from 'react-bootstrap';
import EducationIcon from '../../../../assets/images/Ic_Education.png';
import _ from 'lodash';
import CandidateSchoolingInfoPanel from './candidateSchoolingInfoPanel';
import CandidateDegreeInfoPanel from './candidateDegreeInfoPanel';
import { CandidatePostLoginService } from '../../../../services/candidatePostLoginService';
import { MasterDataService } from '../../../../services/masterDataService';
import CloseIcon from '../../../../assets/images/Ic_close.png';
import ReactDatePicker from 'react-datepicker';

const CandidateEducationInfo = ({ education = {}, candidateId, candidateData, fetchCandidateData }) => {
  const [showAll, setShowAll] = useState(false);
  const [editedEducation, setEditedEducation] = useState({});
  const [editingIndexes, setEditingIndexes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalItemIndex, setModalItemIndex] = useState(null);
  const [savingEducation, setSavingEducation] = useState(false);
  const [modalEditData, setModalEditData] = useState(null);
  const [ugDegrees, setUgDegrees] = useState(['']);
  const [pgDegrees, setPgDegrees] = useState(['']);
  const [errorMessage, setErrorMessage] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [modalEditDataList, setModalEditDataList] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [modalMode, setModalMode] = useState('add');



  useEffect(() => {
    MasterDataService.getAllUgDegrees().then((res) => setUgDegrees(['', ...res.data]));
    MasterDataService.getAllPgDegrees().then((res) => setPgDegrees(['', ...res.data]));
  }, []);

  useEffect(() => {
    setEditedEducation(education);
  }, [education]);

  const calculateEducationLength = (education) => {
    const schoolingItems = [
      _.get(education, 'tenth'),
      _.get(education, 'twelfth')
    ].filter((item) => item && isValidSchoolingData(item));
    const graduationLst = _.get(education, 'hasGraduationDegree') === 'YES' ? _.get(education, 'graduationLst') : [];
    const pgLst = _.get(education, 'hasPg') === 'YES' ? _.get(education, 'pgLst') : [];
    const doctorateLst = _.get(education, 'hasDoctorate') === 'YES' ? _.get(education, 'doctorates') : [];
    return schoolingItems.length + graduationLst.length + pgLst.length + doctorateLst.length;
  };

  const isValidSchoolingData = (data) => {
    return (
      !!_.get(data, 'schoolName') ||
      !!_.get(data, 'schoolDetails.startYear') ||
      !!_.get(data, 'schoolDetails.endYear') ||
      !!_.get(data, 'schoolDetails.cgpa') ||
      !!_.get(data, 'schoolDetails.percentage')
    );
  };

  const schoolingItems = [
    { type: 'schooling', title: '12th Grade', path: 'twelfth', data: _.get(editedEducation, 'twelfth') },
    { type: 'schooling', title: '10th Grade', path: 'tenth', data: _.get(editedEducation, 'tenth') },
  ].filter((item) => item.data && isValidSchoolingData(item.data));

  const degreeItems = [
    ...(_.get(editedEducation, 'hasDoctorate') === 'YES' ? (_.get(editedEducation, 'doctorates') || []).map((deg, idx) => ({ type: 'degree', path: `doctorates[${idx}]`, data: deg })) : []),
    ...(_.get(editedEducation, 'hasPg') === 'YES' ? (_.get(editedEducation, 'pgLst') || []).map((deg, idx) => ({ type: 'degree', path: `pgLst[${idx}]`, data: deg })) : []),
    ...(_.get(editedEducation, 'hasGraduationDegree') === 'YES' ? (_.get(editedEducation, 'graduationLst') || []).map((deg, idx) => ({ type: 'degree', path: `graduationLst[${idx}]`, data: deg })) : []),
  ];

  const allItems = [...degreeItems, ...schoolingItems];
  const visibleItems = showAll ? allItems : allItems.slice(0, 4);

  const handleModalFieldChange = (fieldPath, value) => {
    setModalEditData(prev => {
      const updated = _.cloneDeep(prev);
      _.set(updated, fieldPath, value);
      return updated;
    });
  };
  const validateDegreeFields = (degreeData) => {
    const errors = [];

    if (!degreeData.degree || degreeData.degree.trim() === '') {
      errors.push('Degree');
    }

    if (!degreeData.specialisation || degreeData.specialisation.trim() === '') {
      errors.push('Specialisation');
    }
    if (!degreeData.typeOfCourse || degreeData.typeOfCourse.trim() === '') {
      errors.push('Type of Course');
    }
    if (!degreeData.universityOrCollege || degreeData.universityOrCollege.trim() === '') {
      errors.push('University / College Name');
    }
    const hasBackPapers = _.get(degreeData, 'universityCollegeDetails.hasBackPapers') === 'YES';
    const backPapers = _.get(degreeData, 'universityCollegeDetails.backPapers', []);

    if (hasBackPapers) {
      backPapers.forEach((bp, idx) => {
        if (!bp.reasons || bp.reasons.trim() === '') {
          errors.push(`Back Paper ${idx + 1} Reason`);
        }
      });
    }

    return errors;
  };
  const validateSchoolFields = (schoolData) => {
    const errors = [];

    const hasBackPapers = _.get(schoolData, 'hasBackPapers') === 'YES';
    const backPapers = _.get(schoolData, 'backPapers', []);

    if (hasBackPapers) {
      backPapers.forEach((bp, idx) => {
        if (!bp.reasons || bp.reasons.trim() === '') {
          errors.push(`School Back Paper ${idx + 1} Reason`);
        }
      });
    }
    return errors;
  };

  const handleEdit = (item) => {
    setModalMode('edit');
    setModalItemIndex(null);
    // const item = allItems[index];
    const clonedData = _.cloneDeep(item.data);

    if (item.type === 'degree') {
      const pathMatch = item.path.match(/^(graduationLst|pgLst|doctorates)\[(\d+)\]$/);
      if (pathMatch) {
        clonedData._degreeType = pathMatch[1];
        clonedData._index = parseInt(pathMatch[2], 10);
      }
      setModalEditDataList([clonedData]);
    }

    if (item.type === 'schooling') {
      clonedData._gradeType = item.path;

      clonedData.schoolDetails = clonedData.schoolDetails || {};
      clonedData.schoolDetails.hasBackPapers = clonedData.schoolDetails.hasBackPapers || 'NO';
      clonedData.schoolDetails.backPapers = clonedData.schoolDetails.backPapers || [];
    }

    setModalEditData(clonedData);
    setShowModal(true);
  };

  const validateField = (field, value, relatedFields = {}) => {
    const currentYear = new Date().getFullYear();
    const trimmedValue = typeof value === 'string' ? value.trim() : value;

    if (field === 'specialisation' || field === 'universityOrCollege') {
      if (typeof trimmedValue === 'string' && (trimmedValue.length < 2 || trimmedValue.length > 100)) {
        return `${field === 'specialisation' ? 'Specialisation' : 'University name'} must be 2–100 characters`;
      }
    }

    if (field === 'cgpa') {
      const cgpaRegex = /^\d{1,2}(\.\d{1,2})?$/;
      if (trimmedValue && !cgpaRegex.test(trimmedValue)) {
        return 'Enter a valid CGPA or percentage (e.g. 8.5 or 75.25)';
      }
    }

    if (field === 'reasons') {
      if (typeof trimmedValue === 'string' && trimmedValue.length > 250) {
        return 'Reason cannot exceed 250 characters';
      }
    }

    if (field === 'startYear' || field === 'endYear') {
      const year = typeof trimmedValue === 'number' ? trimmedValue : parseInt(trimmedValue, 10);
      if (year > currentYear) {
        return `Year cannot be in the future (${currentYear})`;
      }

      const otherYear = field === 'startYear' ? relatedFields.endYear : relatedFields.startYear;

      if (
        typeof year === 'number' &&
        typeof otherYear === 'number' &&
        field === 'startYear' &&
        year > otherYear
      ) {
        return 'Start year cannot be greater than end year';
      }

      if (
        typeof year === 'number' &&
        typeof otherYear === 'number' &&
        field === 'endYear' &&
        otherYear > year
      ) {
        return 'End year cannot be before start year';
      }
    }

    return '';
  };


  const handleFieldChangeAt = (index, fieldPath, value) => {
    setModalEditDataList(prev => {
      const updated = _.cloneDeep(prev);
      _.set(updated[index], fieldPath, value);
      return updated;
    });

    const fieldName = fieldPath.split('.').pop();
    const errorKey = fieldPath.includes('reasons') ? `backPaperReason_${index}` : fieldName;

    let relatedFields = {};

    if (fieldName === 'startYear' || fieldName === 'endYear') {
      const fullEntry = _.cloneDeep(modalEditDataList[index]);

      const segments = fieldPath.split('.');
      const arrayRegex = /(\w+)\[(\d+)\]/;

      for (let i = 0; i < segments.length; i++) {
        const match = arrayRegex.exec(segments[i]);
        if (match) {
          const [_, arrayName, arrayIdx] = match;
          const base = segments.slice(0, i).join('.');
          const arrayPath = `${base}.${arrayName}`;
          const siblingObj = _.get(fullEntry, arrayPath)?.[arrayIdx];

          if (siblingObj) {
            relatedFields = {
              startYear: siblingObj.startYear,
              endYear: siblingObj.endYear,
            };
          }
          break;
        }
      }

      if (_.isEmpty(relatedFields)) {
        const parentPath = segments.slice(0, -1).join('.');
        const parentObj = _.get(fullEntry, parentPath);
        relatedFields = {
          startYear: parentObj?.startYear,
          endYear: parentObj?.endYear,
        };
      }

      relatedFields[fieldName] = value;
    }

    const errorMessage = validateField(fieldName, value, relatedFields);

    setFieldErrors(prev => ({
      ...prev,
      [errorKey]: errorMessage,
    }));
  };

  const handleRemove = (indexToRemove) => {
    setModalEditDataList((prevList) =>
      prevList.map((item, idx) =>
        idx === indexToRemove ? { ...item, _markedForDeletion: true } : item
      )
    );
  };

  const handleSave = async () => {
    setSavingEducation(true);

    const hasLiveErrors = Object.values(fieldErrors).some((err) => err && err.trim() !== '');
    if (hasLiveErrors) {
      setErrorMessage("Please fix the field-level validation errors before saving.");
      setSavingEducation(false);
      return;
    }

    try {
      const updated = _.cloneDeep(editedEducation);

      // SCHOOL CASE
      if (modalEditData?._gradeType === 'tenth' || modalEditData?._gradeType === 'twelfth') {
        const entry = { ...modalEditData };

        const schoolValidationErrors = validateSchoolFields(entry.schoolDetails);
        if (schoolValidationErrors.length > 0) {
          setErrorMessage(`Please fill the required field(s):\n- ${schoolValidationErrors.join(', ')}`);
          setSavingEducation(false);
          return;
        }

        delete entry._gradeType;
        updated[modalEditData._gradeType] = entry;
      }

      // DEGREE CASE
      else if (modalEditDataList.length && modalEditDataList[0]?._degreeType) {
        const listKey = modalEditDataList[0]._degreeType;
        if (!Array.isArray(updated[listKey])) updated[listKey] = [];

        const markedForDeletion = modalEditDataList.filter((entry) => entry._markedForDeletion);
        updated[listKey] = updated[listKey].filter((deg, idx) => {
          return !markedForDeletion.some(entry =>
            (entry._index !== undefined && idx === entry._index) ||
            (
              deg.degree === entry.degree &&
              deg.specialisation === entry.specialisation &&
              deg.universityOrCollege === entry.universityOrCollege
            )
          );
        });

        for (const entry of modalEditDataList) {
          if (entry._markedForDeletion) continue;

          const cleanDegree = _.cloneDeep(entry);
          delete cleanDegree._degreeType;
          const index = cleanDegree._index;
          delete cleanDegree._index;



          const validationErrors = validateDegreeFields(cleanDegree);
          if (validationErrors.length > 0) {
            setErrorMessage(`Please fill the required field(s):\n- ${validationErrors.join(', ')}`);
            setSavingEducation(false);
            return;
          }

          const alreadyExists = updated[listKey].some(degree =>
            degree.degree === cleanDegree.degree &&
            degree.specialisation === cleanDegree.specialisation &&
            degree.universityOrCollege === cleanDegree.universityOrCollege &&
            degree.universityCollegeDetails?.startYear === cleanDegree.universityCollegeDetails?.startYear &&
            degree.universityCollegeDetails?.endYear === cleanDegree.universityCollegeDetails?.endYear
          );

          if (typeof index === 'number' && index >= 0 && index < updated[listKey].length) {
            updated[listKey][index] = cleanDegree;
          } else if (!alreadyExists) {
            updated[listKey].push(cleanDegree);
          }
        }

        updated[listKey] = updated[listKey].filter(degree =>
          degree.degree?.trim() || degree.specialisation?.trim() || degree.universityOrCollege?.trim()
        );

        if (listKey === 'graduationLst') updated.hasGraduationDegree = updated[listKey].length ? 'YES' : 'NO';
        if (listKey === 'pgLst') updated.hasPg = updated[listKey].length ? 'YES' : 'NO';
        if (listKey === 'doctorates') updated.hasDoctorate = updated[listKey].length ? 'YES' : 'NO';
      }
      if (updated.hasDoctorate !== 'YES' || updated.doctorates.length === 0) {
        updated.hasDoctorate = 'NO';
        updated.doctorates = [];
      }
      if (updated.hasPg !== 'YES' || updated.pgLst.length === 0) {
        updated.hasPg = 'NO';
        updated.pgLst = [];
      }
      if (updated.hasGraduationDegree !== 'YES' || updated.graduationLst.length === 0) {
        updated.hasGraduationDegree = 'NO';
        updated.graduationLst = [];
      }


      setEditedEducation(updated);

      const panelPayload = {
        // ...(updated.tenth ? { tenth: updated.tenth } : {}),
        // ...(updated.twelfth ? { twelfth: updated.twelfth } : {}),
        tenth: updated.tenth ?? null,
        twelfth: updated.twelfth ?? null,
        hasGraduationDegree: updated.hasGraduationDegree || 'NO',
        graduationLst: updated.graduationLst || [],
        hasPg: updated.hasPg || 'NO',
        pgLst: updated.pgLst || [],
        hasDoctorate: updated.hasDoctorate || 'NO',
        doctorates: updated.doctorates || [],
        otherCertificates: updated.otherCertificates || [],
        educationalDocs: updated.educationalDocs || [],
        assessmentFiles: updated.assessmentFiles || [],
      }
      await CandidatePostLoginService.submitPanelByType('EDUCATIONAL_DETAILS', panelPayload);
      setShowModal(false);
      await fetchCandidateData();
    } catch (error) {
      console.error('Failed to save education:', error);
    } finally {
      setSavingEducation(false);
    }
  };

  const handleSchoolNameChange = (value) => {
    handleModalFieldChange('schoolName', value);
    if (value.trim() && (value.trim().length < 2 || value.trim().length > 100)) {
      setFieldErrors(prev => ({ ...prev, schoolName: 'School name must be 2–100 characters' }));
    } else {
      setFieldErrors(prev => ({ ...prev, schoolName: '' }));
    }
  };

  const handleSchoolStartYearChange = (val) => {
    const startYear = val ? val.getFullYear() : '';
    const endYear = modalEditData?.schoolDetails?.endYear;

    handleModalFieldChange('schoolDetails.startYear', startYear);

    let error = '';
    const currentYear = new Date().getFullYear();

    if (startYear > currentYear) {
      error = `Start year cannot be in the future (${currentYear})`;
    } else if (endYear && startYear > endYear) {
      error = 'Start year cannot be greater than end year';
    }

    setFieldErrors(prev => ({ ...prev, schoolStartYear: error }));
  };
  const handleSchoolEndYearChange = (val) => {
    const endYear = val ? val.getFullYear() : '';
    const startYear = modalEditData?.schoolDetails?.startYear;

    handleModalFieldChange('schoolDetails.endYear', endYear);

    let error = '';
    const currentYear = new Date().getFullYear();

    if (endYear > currentYear) {
      error = `End year cannot be in the future (${currentYear})`;
    } else if (startYear && startYear > endYear) {
      error = 'End year cannot be before start year';
    }

    setFieldErrors(prev => ({ ...prev, schoolEndYear: error }));
  };
  const handleBackPaperStartYearChange = (val, idx) => {
    const startYear = val ? val.getFullYear() : '';
    const updated = [...modalEditData.schoolDetails.backPapers];
    const endYear = updated[idx]?.endYear;

    updated[idx].startYear = startYear;
    handleModalFieldChange('schoolDetails.backPapers', updated);

    let error = '';
    const currentYear = new Date().getFullYear();

    if (startYear > currentYear) {
      error = `Start year cannot be in the future (${currentYear})`;
    } else if (endYear && startYear > endYear) {
      error = 'Start year cannot be after end year';
    }

    setFieldErrors(prev => ({
      ...prev,
      [`backPaperStartYear-${idx}`]: error
    }));
  };

  const handleBackPaperEndYearChange = (val, idx) => {
    const endYear = val ? val.getFullYear() : '';
    const updated = [...modalEditData.schoolDetails.backPapers];
    const startYear = updated[idx]?.startYear;

    updated[idx].endYear = endYear;
    handleModalFieldChange('schoolDetails.backPapers', updated);

    let error = '';
    const currentYear = new Date().getFullYear();

    if (endYear > currentYear) {
      error = `End year cannot be in the future (${currentYear})`;
    } else if (startYear && startYear > endYear) {
      error = 'End year cannot be before start year';
    }

    setFieldErrors(prev => ({
      ...prev,
      [`backPaperEndYear-${idx}`]: error
    }));
  };

  const handleCgpaChange = (value) => {
    handleModalFieldChange('schoolDetails.cgpa', value);
    const cgpaRegex = /^\d{1,2}(\.\d{1,2})?$/;
    if (value.trim() && !cgpaRegex.test(value.trim())) {
      setFieldErrors(prev => ({ ...prev, cgpa: 'Enter a valid number (e.g. 8.5 or 75.25)' }));
    } else {
      setFieldErrors(prev => ({ ...prev, cgpa: '' }));
    }
  };

  const handleBackPaperReasonChange = (index, value) => {
    const updated = [...modalEditData.schoolDetails.backPapers];
    updated[index].reasons = value;
    handleModalFieldChange('schoolDetails.backPapers', updated);

    const errors = { ...fieldErrors };
    errors[`backPaperReason_${index}`] = value.length > 250 ? 'Reason cannot exceed 250 characters' : '';
    setFieldErrors(errors);
  };

  const handleDegreeStartYearChange = (val, index) => {
    const year = val ? val.getFullYear() : '';
    handleFieldChangeAt(index, 'universityCollegeDetails.startYear', year);

    const endYear = modalEditDataList[index]?.universityCollegeDetails?.endYear;
    const isInvalid = endYear && year && parseInt(year) > parseInt(endYear);

    setFieldErrors((prev) => ({
      ...prev,
      [`degreeStartYear-${index}`]: isInvalid ? 'Start year cannot be after end year' : '',
    }));
  };

  const handleDegreeEndYearChange = (val, index) => {
    const year = val ? val.getFullYear() : '';
    handleFieldChangeAt(index, 'universityCollegeDetails.endYear', year);

    const startYear = modalEditDataList[index]?.universityCollegeDetails?.startYear;
    const isInvalid = startYear && year && parseInt(year) < parseInt(startYear);

    setFieldErrors((prev) => ({
      ...prev,
      [`degreeEndYear-${index}`]: isInvalid ? 'End year cannot be before start year' : '',
    }));
  };

  const handleDegreeBackPaperStartYearChange = (val, degreeIdx, bpIdx) => {
    const year = val ? val.getFullYear() : '';
    const updated = [...modalEditDataList];
    updated[degreeIdx].universityCollegeDetails.backPapers[bpIdx].startYear = year;
    handleFieldChangeAt(degreeIdx, 'universityCollegeDetails.backPapers', updated[degreeIdx].universityCollegeDetails.backPapers);

    const endYear = updated[degreeIdx].universityCollegeDetails.backPapers[bpIdx].endYear;
    const isInvalid = endYear && year && parseInt(year) > parseInt(endYear);

    setFieldErrors((prev) => ({
      ...prev,
      [`backPaperStartYear-${degreeIdx}-${bpIdx}`]: isInvalid ? 'Start year cannot be after end year' : '',
    }));
  };

  const handleDegreeBackPaperEndYearChange = (val, degreeIdx, bpIdx) => {
    const year = val ? val.getFullYear() : '';
    const updated = [...modalEditDataList];
    updated[degreeIdx].universityCollegeDetails.backPapers[bpIdx].endYear = year;
    handleFieldChangeAt(degreeIdx, 'universityCollegeDetails.backPapers', updated[degreeIdx].universityCollegeDetails.backPapers);

    const startYear = updated[degreeIdx].universityCollegeDetails.backPapers[bpIdx].startYear;
    const isInvalid = startYear && year && parseInt(year) < parseInt(startYear);

    setFieldErrors((prev) => ({
      ...prev,
      [`backPaperEndYear-${degreeIdx}-${bpIdx}`]: isInvalid ? 'End year cannot be before start year' : '',
    }));
  };

  const handleCancel = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal) setFieldErrors({});
  }, [showModal]);



  const degreeTypeLabels = {
    graduationLst: 'Graduation',
    pgLst: 'Post Graduation',
    doctorates: 'Doctorate',
  };

  const getGlobalDegreeNumber = (entry) => {
    if (typeof entry._index === 'number') {
      return entry._index + 1;
    }

    const list = editedEducation?.[entry._degreeType] || [];
    return list.length + 1;
  };

  const openSchooling = (type) => {
    setModalMode('add');
    setModalItemIndex(null);
    setModalEditData({
      schoolName: '',
      schoolDetails: {
        startYear: '',
        endYear: '',
        cgpa: '',
        hasBackPapers: 'NO',
        backPapers: [],
      },
      _gradeType: type,
    });
    setShowModal(true);
    setShowPopup(false);
  };

  const openHigherEducation = (type) => {
    setModalMode('add');
    const newEntry = {
      degree: '',
      specialisation: '',
      typeOfCourse: '',
      universityOrCollege: '',
      universityCollegeDetails: {
        startYear: '',
        endYear: '',
        cgpa: '',
        hasBackPapers: 'NO',
        backPapers: []
      },
      _degreeType: type,
    };
    const entryClone = _.cloneDeep(newEntry);
    setModalItemIndex(null);

    setModalEditData(entryClone);
    setModalEditDataList([entryClone]);
    setShowModal(true);
    setShowPopup(false);
  };

  return (
    <Container className="pt-2 education-container">
      {errorMessage && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-box">
            <div className="custom-alert-content">
              <p>{errorMessage}</p>
              <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      <Row className="align-items-center">
        <Col>
          <h3 className="candidate-heading">
            Education ({calculateEducationLength(editedEducation)})
            <img src={EducationIcon} alt="Education" className="profile-work-experience-nav-icon" />
          </h3>
        </Col>
        <Col className="text-end">
          <div
            style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
            onClick={() => setShowPopup(true)}
            className='candidate-detail-add-head'
          >
            <FontAwesomeIcon icon={faPlusCircle} /> Add Education
          </div>
        </Col>
      </Row>

      <Modal show={showPopup} onHide={() => setShowPopup(false)} centered backdrop="static" className="candidate-custom-modal" dialogClassName="small-education-modal">
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title className="w-100 text-center">Select Education Type</Modal.Title>
          <img
            src={CloseIcon}
            alt="Close"
            onClick={() => setShowPopup(false)}
            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
          />
        </Modal.Header>
        <Modal.Body>
          {!isValidSchoolingData(_.get(education, 'tenth', {})) && (

            <div className="mb-2"
              style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
              onClick={() => openSchooling('tenth')}
            >
              <FontAwesomeIcon icon={faPlusCircle} /> Add 10th Grade
            </div>
          )}
          {!isValidSchoolingData(_.get(education, 'twelfth', {})) && (

            <div className="mb-2"
              style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
              onClick={() => openSchooling('twelfth')}
            >
              <FontAwesomeIcon icon={faPlusCircle} /> Add 12th Grade
            </div>
          )}
          <div className="mb-2"
            style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
            onClick={() => openHigherEducation('graduationLst')}
          >
            <FontAwesomeIcon icon={faPlusCircle} /> Add Graduation
          </div>
          <div className="mb-2"
            style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
            onClick={() => openHigherEducation('pgLst')}
          >
            <FontAwesomeIcon icon={faPlusCircle} /> Add Post Graduation
          </div>
          <div className="mb-2"
            style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
            onClick={() => openHigherEducation('doctorates')}
          >
            <FontAwesomeIcon icon={faPlusCircle} /> Add Doctorate
          </div>
        </Modal.Body>
      </Modal>

      <Container>
        {(visibleItems || []).map((item, index) => (
          <div key={index} className="d-flex justify-content-between align-items-start mb-3">
            <div style={{ flex: 1 }}>
              {item.type === 'schooling' ? (
                <CandidateSchoolingInfoPanel
                  colorSeed={Math.random()}
                  schoolData={item.data}
                  title={item.title}
                  isEditing={false}
                />
              ) : (
                <CandidateDegreeInfoPanel
                  colorSeed={Math.random()}
                  pgData={item.data}
                  isEditing={false}
                />
              )}
            </div>
            <div className="ms-3 mt-1">
              <button onClick={() => handleEdit(item)} className="candidate-profile-edit-button">
                <FontAwesomeIcon icon={faPen} />
              </button>
            </div>
          </div>
        ))}
      </Container>

      {(allItems?.length || 0) > 4 && (
        <Row>
          <Col>
            <a className="education-view-all" onClick={() => setShowAll(prev => !prev)}>
              {showAll ? 'View Less' : 'View All'}&nbsp;
              <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown} />
            </a>
          </Col>
        </Row>
      )}

      <Modal show={showModal} onHide={handleCancel} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>
            {modalEditData?._gradeType === 'tenth' && (modalMode === 'edit' ? 'Edit 10th Grade Info' : 'Add 10th Grade Info')}
            {modalEditData?._gradeType === 'twelfth' && (modalMode === 'edit' ? 'Edit 12th Grade Info' : 'Add 12th Grade Info')}
            {modalEditData?._degreeType === 'graduationLst' && (modalMode === 'edit' ? 'Edit Graduation Info' : 'Add Graduation Info')}
            {modalEditData?._degreeType === 'pgLst' && (modalMode === 'edit' ? 'Edit PG Info' : 'Add PG Info')}
            {modalEditData?._degreeType === 'doctorates' && (modalMode === 'edit' ? 'Edit Doctorate Info' : 'Add Doctorate Info')}




            {!modalEditData?._gradeType && !modalEditData?._degreeType && (modalMode === 'edit' ? 'Edit Education Info' : 'Add Education Info')}
          </Modal.Title>

          <img
            src={CloseIcon}
            alt="Close"
            onClick={handleCancel}
            style={{
              cursor: 'pointer',
              width: '24px',
              height: '24px',
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <style>
            {`
    .react-datepicker__input-container input {
      border: 1px solid #ced4da !important;
      box-shadow: none !important;
    }

    .react-datepicker__input-container input:focus {
      border: 1px solid #ced4da !important;
      box-shadow: none !important;
      outline: none;
    }
  `}
          </style>
          {showModal && (
            modalEditData?._gradeType ? (
              <div>
                <h5 className="mb-4">
                  {allItems[modalItemIndex]?.title ||
                    (modalEditData?._gradeType === 'tenth' && '10th Grade') ||
                    (modalEditData?._gradeType === 'twelfth' && '12th Grade') ||
                    (modalEditData?._degreeType === 'graduationLst' && 'Graduation') ||
                    (modalEditData?._degreeType === 'pgLst' && 'Post Graduation') ||
                    (modalEditData?._degreeType === 'doctorates' && 'Doctorate')}
                </h5>

                <div className="mb-3">
                  <label className="form-label">School Name</label>
                  <input
                    style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                    type="text"
                    spellCheck='false'
                    className={`form-control ${fieldErrors.schoolName ? 'is-invalid' : ''}`}
                    value={_.get(modalEditData, 'schoolName') || ''}
                    onChange={(e) => handleSchoolNameChange(e.target.value)}

                  />
                  {fieldErrors.schoolName && (
                    <div className="invalid-feedback">{fieldErrors.schoolName}</div>
                  )}
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>School Start Year</Form.Label>
                  <div className={fieldErrors.schoolStartYear ? 'is-invalid' : ''}>

                    <ReactDatePicker
                      selected={
                        modalEditData?.schoolDetails?.startYear
                          ? new Date(new Date().setFullYear(modalEditData.schoolDetails.startYear))
                          : null
                      }
                      onChange={handleSchoolStartYearChange}

                      showYearPicker
                      dateFormat="yyyy"
                      className={`form-control ${fieldErrors.schoolStartYear ? 'is-invalid' : ''}`}
                      maxDate={new Date()}
                      autoComplete="off"
                    />
                    {fieldErrors.schoolStartYear && (
                      <div className="invalid-feedback d-block">
                        {fieldErrors.schoolStartYear}
                      </div>
                    )}
                  </div>
                </Form.Group>


                <Form.Group className="mb-3">
                  <Form.Label>School End Year</Form.Label>
                  <div className={fieldErrors.schoolEndYear ? 'is-invalid' : ''}>

                    <ReactDatePicker
                      selected={
                        modalEditData?.schoolDetails?.endYear
                          ? new Date(new Date().setFullYear(modalEditData.schoolDetails.endYear))
                          : null
                      }
                      onChange={handleSchoolEndYearChange}
                      showYearPicker
                      dateFormat="yyyy"
                      className={`form-control ${fieldErrors.schoolEndYear ? 'is-invalid' : ''}`}
                      maxDate={new Date()}
                      autoComplete="off"
                    />
                    {fieldErrors.schoolEndYear && (
                      <div className="invalid-feedback d-block">
                        {fieldErrors.schoolEndYear}
                      </div>
                    )}
                  </div>
                </Form.Group>

                <div className="mb-3">
                  <label className="form-label">CGPA / Percentage</label>
                  <input
                    style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                    type="text"
                    spellCheck='false'
                    className={`form-control ${fieldErrors.cgpa ? 'is-invalid' : ''}`}
                    value={_.get(modalEditData, 'schoolDetails.cgpa') || ''}
                    onChange={(e) => handleCgpaChange(e.target.value)}
                  />
                  {fieldErrors.cgpa && <div className="invalid-feedback">{fieldErrors.cgpa}</div>}
                </div>

                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="hasBackPapersCheck"
                    checked={_.get(modalEditData, 'schoolDetails.hasBackPapers') === 'YES'}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      handleModalFieldChange('schoolDetails.hasBackPapers', checked ? 'YES' : 'NO');
                      if (!checked) {
                        handleModalFieldChange('schoolDetails.backPapers', []);
                      }
                    }}
                  />
                  <label className="form-check-label ms-2" htmlFor="hasBackPapersCheck">
                    Has Back Papers?
                  </label>
                </div>
                {_.get(modalEditData, 'schoolDetails.hasBackPapers') === 'YES' &&
                  (!modalEditData.schoolDetails.backPapers || modalEditData.schoolDetails.backPapers.length === 0) && (
                    <div
                      style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                      onClick={() => {
                        handleModalFieldChange('schoolDetails.backPapers', [
                          { startYear: '', endYear: '', reasons: '' }
                        ]);
                      }}
                    >
                      <FontAwesomeIcon icon={faPlusCircle} /> Add Back Paper
                    </div>
                  )}

                {modalEditData?.schoolDetails?.hasBackPapers === 'YES' &&
                  Array.isArray(modalEditData.schoolDetails.backPapers) &&
                  modalEditData.schoolDetails.backPapers.length > 0 && (
                    <>
                      <h5 className="mb-3">Back Papers</h5>
                      {modalEditData.schoolDetails.backPapers.map((bp, idx) => (
                        <div key={`modal-bp-${idx}`} className="mb-3 border p-3 rounded">
                          <Form.Group className="mb-2">
                            <Form.Label>Start Year</Form.Label>
                            <div className={fieldErrors[`backPaperStartYear-${idx}`] ? 'is-invalid' : ''}>

                              <ReactDatePicker
                                selected={bp.startYear ? new Date(new Date().setFullYear(bp.startYear)) : null}

                                onChange={(val) => handleBackPaperStartYearChange(val, idx)}

                                showYearPicker
                                dateFormat="yyyy"
                                className={`form-control ${fieldErrors[`backPaperStartYear-${idx}`] ? 'is-invalid' : ''}`}
                                maxDate={new Date()}
                                autoComplete="off"
                              />
                              {fieldErrors[`backPaperStartYear-${idx}`] && (
                                <div className="invalid-feedback d-block">
                                  {fieldErrors[`backPaperStartYear-${idx}`]}
                                </div>
                              )}
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-2">
                            <Form.Label>End Year</Form.Label>
                            <div className={fieldErrors[`backPaperEndYear-${idx}`] ? 'is-invalid' : ''}>

                              <ReactDatePicker
                                selected={bp.endYear ? new Date(new Date().setFullYear(bp.endYear)) : null}

                                onChange={(val) => handleBackPaperEndYearChange(val, idx)}

                                showYearPicker
                                dateFormat="yyyy"
                                className={`form-control ${fieldErrors[`backPaperEndYear-${idx}`] ? 'is-invalid' : ''}`}
                                maxDate={new Date()}
                                autoComplete="off"
                              />
                              {fieldErrors[`backPaperEndYear-${idx}`] && (
                                <div className="invalid-feedback d-block">
                                  {fieldErrors[`backPaperEndYear-${idx}`]}
                                </div>
                              )}
                            </div>
                          </Form.Group>
                          <div>
                            <label className="form-label">Reason <span style={{ color: 'red' }}>*</span></label>
                            <input
                              style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                              type="text"
                              spellCheck='false'
                              className={`form-control ${fieldErrors[`backPaperReason_${idx}`] ? 'is-invalid' : ''}`}
                              value={bp.reasons || ''}
                              onChange={(e) => handleBackPaperReasonChange(idx, e.target.value)}
                            />
                            {fieldErrors[`backPaperReason_${idx}`] && (
                              <div className="invalid-feedback">{fieldErrors[`backPaperReason_${idx}`]}</div>
                            )}
                          </div>
                          <div className="text-end"

                            size="sm"
                            style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                            onClick={() => {
                              const updated = [...modalEditData.schoolDetails.backPapers];
                              updated.splice(idx, 1);
                              handleModalFieldChange('schoolDetails.backPapers', updated);
                            }}
                          >
                            <FontAwesomeIcon icon={faMinusCircle} />
                          </div>
                        </div>
                      ))}
                      <div
                        style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }} onClick={() => {
                          const updated = [...(modalEditData.schoolDetails.backPapers || [])];
                          updated.push({ startYear: '', endYear: '', reasons: '' });
                          handleModalFieldChange('schoolDetails.backPapers', updated);
                        }}
                      >
                        <FontAwesomeIcon icon={faPlusCircle} />  Add Back Paper
                      </div>

                    </>
                  )}

              </div>

            ) : (
              <div>
                {modalEditDataList.map((entry, index) => (
                  <div key={index} className="">
                    {entry._markedForDeletion ? (
                      <div className="alert alert-warning mb-3">
                        This entry will be removed once you click <strong>Save</strong>.
                      </div>
                    ) : (
                      <>
                        <h5 className="mb-3">
                          {/* {degreeTypeLabels[entry._degreeType] || 'Unknown Degree'} – {getGlobalDegreeNumber(entry, index)} */}
                          {degreeTypeLabels[entry._degreeType]} – {getGlobalDegreeNumber(entry)}

                        </h5>

                        <div className="mb-3">
                          <label className="form-label">Degree <span style={{ color: 'red' }}>*</span></label>
                          {entry._degreeType === 'doctorates' ? (
                            <input
                              type="text"
                              style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                              spellCheck='false'
                              className="form-control"
                              value={_.get(entry, 'degree') || ''}
                              onChange={(e) => handleFieldChangeAt(index, 'degree', e.target.value)}
                            />
                          ) : (
                            // <select
                            //   className="form-select"
                            //   style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            //   value={_.get(entry, 'degree') || ''}
                            //   onChange={(e) => handleFieldChangeAt(index, 'degree', e.target.value)}
                            // >
                            <>
                              <select
                                className="form-select"
                                style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                value={_.get(entry, 'degree') || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  handleFieldChangeAt(index, 'degree', value);


                                }}
                              >

                                {(entry._degreeType === 'pgLst' ? pgDegrees : ugDegrees).map((deg, idx) => (
                                  <option key={idx} value={deg}>{deg}</option>
                                ))}
                              </select>

                            </>
                          )}
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Specialisation <span style={{ color: 'red' }}>*</span></label>
                          <input
                            type="text"
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            spellCheck='false'
                            className={`form-control ${fieldErrors.specialisation ? 'is-invalid' : ''}`}
                            value={_.get(entry, 'specialisation') || ''}
                            onChange={(e) => handleFieldChangeAt(index, 'specialisation', e.target.value)}
                          />
                          {fieldErrors.specialisation && (
                            <div className="invalid-feedback">{fieldErrors.specialisation}</div>
                          )}
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Type of Course <span style={{ color: 'red' }}>*</span></label>
                          <select
                            className="form-select"
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            value={_.get(entry, 'typeOfCourse') || ''}
                            onChange={(e) => handleFieldChangeAt(index, 'typeOfCourse', e.target.value)}
                          >
                            <option value="">--Select--</option>
                            <option value="FULL_TIME">Full Time</option>
                            <option value="PART_TIME">Part Time</option>
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">University / College Name <span style={{ color: 'red' }}>*</span></label>
                          <input
                            type="text"
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            spellCheck='false'
                            className={`form-control ${fieldErrors.universityOrCollege ? 'is-invalid' : ''}`}
                            value={_.get(entry, 'universityOrCollege') || ''}
                            onChange={(e) => handleFieldChangeAt(index, 'universityOrCollege', e.target.value)}
                          />
                          {fieldErrors.universityOrCollege && (
                            <div className="invalid-feedback">{fieldErrors.universityOrCollege}</div>
                          )}
                        </div>

                        <Form.Group className="mb-3">
                          <Form.Label>Start Year</Form.Label>
                          <ReactDatePicker
                            selected={
                              entry?.universityCollegeDetails?.startYear
                                ? new Date(new Date().setFullYear(entry.universityCollegeDetails.startYear))
                                : null
                            }
                            onChange={(val) => handleDegreeStartYearChange(val, index)}

                            showYearPicker
                            dateFormat="yyyy"
                            className={`form-control ${fieldErrors[`degreeStartYear-${index}`] ? 'is-invalid' : ''}`}
                            maxDate={new Date()}
                            autoComplete="off"
                          />
                          {fieldErrors[`degreeStartYear-${index}`] && (
                            <div className="invalid-feedback d-block">{fieldErrors[`degreeStartYear-${index}`]}</div>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>End Year</Form.Label>
                          <ReactDatePicker
                            selected={
                              entry?.universityCollegeDetails?.endYear
                                ? new Date(new Date().setFullYear(entry.universityCollegeDetails.endYear))
                                : null
                            }
                            onChange={(val) => handleDegreeEndYearChange(val, index)}

                            showYearPicker
                            dateFormat="yyyy"
                            className={`form-control ${fieldErrors[`degreeEndYear-${index}`] ? 'is-invalid' : ''}`}
                            maxDate={new Date()}
                            autoComplete="off"
                          />
                          {fieldErrors[`degreeEndYear-${index}`] && (
                            <div className="invalid-feedback d-block">{fieldErrors[`degreeEndYear-${index}`]}</div>
                          )}
                        </Form.Group>

                        <div className="mb-3">
                          <label className="form-label">CGPA / Percentage</label>
                          <input
                            type="text"
                            style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                            spellCheck='false'
                            className={`form-control ${fieldErrors.cgpa ? 'is-invalid' : ''}`}
                            value={_.get(entry, 'universityCollegeDetails.cgpa') || ''}
                            onChange={(e) => handleFieldChangeAt(index, 'universityCollegeDetails.cgpa', e.target.value)}
                          />
                          {fieldErrors.cgpa && <div className="invalid-feedback">{fieldErrors.cgpa}</div>}
                        </div>

                        <div className="form-check mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`hasBackPapersUniCheck-${index}`}
                            checked={_.get(entry, 'universityCollegeDetails.hasBackPapers') === 'YES'}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              handleFieldChangeAt(index, 'universityCollegeDetails.hasBackPapers', checked ? 'YES' : 'NO');
                              if (!checked) {
                                handleFieldChangeAt(index, 'universityCollegeDetails.backPapers', []);
                              }
                            }}
                          />
                          <label className="form-check-label ms-2" htmlFor={`hasBackPapersUniCheck-${index}`}>
                            Has Back Papers?
                          </label>
                        </div>
                        {_.get(entry, 'universityCollegeDetails.hasBackPapers') === 'YES' &&
                          (!entry.universityCollegeDetails.backPapers || entry.universityCollegeDetails.backPapers.length === 0) && (
                            <div
                              style={{ cursor: 'pointer', fontWeight: '500', color: '#F35824' }}
                              onClick={() => {
                                handleFieldChangeAt(index, 'universityCollegeDetails.backPapers', [
                                  { startYear: '', endYear: '', reasons: '' }
                                ]);
                              }}
                            >
                              <FontAwesomeIcon icon={faPlusCircle} /> Add Back Paper
                            </div>
                          )}

                        {_.get(entry, 'universityCollegeDetails.hasBackPapers') === 'YES' &&
                          (entry.universityCollegeDetails.backPapers || []).length > 0 && (
                            <>
                              <h5 className="mb-3">Back Papers</h5>
                              {entry.universityCollegeDetails.backPapers.map((bp, bpIdx) => (
                                <div key={bpIdx} className="mb-3 border p-3 rounded">
                                  <Form.Group className="mb-2">
                                    <Form.Label>Start Year</Form.Label>
                                    <ReactDatePicker
                                      selected={bp.startYear ? new Date(new Date().setFullYear(bp.startYear)) : null}

                                      onChange={(val) => handleDegreeBackPaperStartYearChange(val, index, bpIdx)}

                                      showYearPicker
                                      dateFormat="yyyy"
                                      className={`form-control ${fieldErrors[`backPaperStartYear-${index}-${bpIdx}`] ? 'is-invalid' : ''}`}
                                      maxDate={new Date()}
                                      autoComplete="off"
                                    />
                                    {fieldErrors[`backPaperStartYear-${index}-${bpIdx}`] && (
                                      <div className="invalid-feedback d-block">{fieldErrors[`backPaperStartYear-${index}-${bpIdx}`]}</div>
                                    )}
                                  </Form.Group>

                                  <Form.Group className="mb-2">
                                    <Form.Label>End Year</Form.Label>
                                    <ReactDatePicker
                                      selected={bp.endYear ? new Date(new Date().setFullYear(bp.endYear)) : null}

                                      onChange={(val) => handleDegreeBackPaperEndYearChange(val, index, bpIdx)}

                                      showYearPicker
                                      dateFormat="yyyy"
                                      className={`form-control ${fieldErrors[`backPaperEndYear-${index}-${bpIdx}`] ? 'is-invalid' : ''}`}
                                      maxDate={new Date()}
                                      autoComplete="off"
                                    />
                                    {fieldErrors[`backPaperEndYear-${index}-${bpIdx}`] && (
                                      <div className="invalid-feedback d-block">{fieldErrors[`backPaperEndYear-${index}-${bpIdx}`]}</div>
                                    )}
                                  </Form.Group>

                                  <div>
                                    <label className="form-label">Reason <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                      type="text"
                                      style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                                      spellCheck='false'
                                      className={`form-control ${fieldErrors[`backPaperReason_${bpIdx}`] ? 'is-invalid' : ''}`}
                                      value={bp.reasons || ''}
                                      onChange={(e) => {
                                        const updated = [...entry.universityCollegeDetails.backPapers];
                                        updated[bpIdx].reasons = e.target.value;
                                        handleFieldChangeAt(index, `universityCollegeDetails.backPapers[${bpIdx}].reasons`, e.target.value)
                                      }}
                                    />
                                    {fieldErrors[`backPaperReason_${bpIdx}`] && (
                                      <div className="invalid-feedback">{fieldErrors[`backPaperReason_${bpIdx}`]}</div>
                                    )}
                                  </div>

                                  <div
                                    className="text-end mt-2"
                                    style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                                    onClick={() => {
                                      const updated = [...entry.universityCollegeDetails.backPapers];
                                      updated.splice(bpIdx, 1);
                                      handleFieldChangeAt(index, 'universityCollegeDetails.backPapers', updated);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faMinusCircle} />
                                  </div>
                                </div>
                              ))
                              }

                              <div
                                style={{ cursor: 'pointer', fontWeight: '500', color: '#F35824' }}
                                onClick={() => {
                                  const updated = [...(entry.universityCollegeDetails.backPapers || [])];
                                  updated.push({ startYear: '', endYear: '', reasons: '' });
                                  handleFieldChangeAt(index, 'universityCollegeDetails.backPapers', updated);
                                }}
                              >
                                <FontAwesomeIcon icon={faPlusCircle} /> Add Back Paper
                              </div>
                            </>
                          )}
                        {modalMode === 'edit' && modalEditDataList.length > 0 && (
                          <div className="text-end mt-3">
                            <span
                              style={{ cursor: 'pointer', fontWeight: '500', color: '#F35824' }}
                              onClick={() => handleRemove(index)}
                            >
                              <FontAwesomeIcon icon={faMinusCircle} />
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                ))}
              </div>
            )
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={handleCancel}
            className="candidate-profile-edit-cancel"
            disabled={savingEducation}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="candidate-profile-edit-save"
            disabled={savingEducation}
          >
            {savingEducation ? 'Saving...' : 'Save'}
          </button>

        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default CandidateEducationInfo;